import axios from 'axios';
import ReactPlayer from "react-player";
import React, { useEffect, useRef, useState } from 'react'
import { isIOS, isMobileSafari, isSafari } from 'react-device-detect';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Modal, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { logo } from '../../Assets/images';
import BASEURL from '../../Config/global';
import { PlaylistIcon, PreviewPauseButton, PreviewPlayButton, crossIcon } from '../../Assets/svg';
import BASEURLFrontend from '../../Config/urls';
import { getAccessToken } from '../../Util/authHeader';
import { decryptId } from '../../Services/Common';
import './style.css';

const SaveShareMixExternal = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { id, sec } = useParams();
    const token = getAccessToken();

    // refs for each ReactPlayer

    const playerRefs = useRef({});
    const timerRef = useRef(null);

    const userPrompts = useSelector((state) => state.user.userPrompts);

    const [audioData, setAudioData] = useState([]);
    const [soundData, setSoundData] = useState([]);
    const [playlistData, setplaylistData] = useState([]);
    const [tracks, setTracks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [limit, setLimit] = useState(180); // default 3 minutes
    const [timeLeft, setTimeLeft] = useState(limit);
    const [isPlaying, setIsPlaying] = useState(false);
    const [_isSharedMixDeleted, setSharedMixDeleted] = useState(false);
    const [propagationCode, setPropagationCode] = useState(null);

    useEffect(() => {
        if (token && id) {
            const originalPath = location.pathname;
            localStorage.setItem("originalPath", originalPath);
            const updatedPath = originalPath.replace(`/${originalPath.split('/')[1]}`, "/home");
            navigate(updatedPath, { replace: true });
        } else {
            if (sec && id) {
                const decryptedSec = decryptId(sec);
                const decryptedId = decryptId(id);
                if (decryptedSec && decryptedId) {
                    const LIMIT = Number(decryptedSec);
                    setLimit(LIMIT)
                    setTimeLeft(LIMIT);
                    if (location.pathname.includes("/share.playlist")) {
                        getDataByPlaylistApi(decryptedId);
                    } else {
                        getDataByApi(decryptedId);
                    }
                }
            } else {
                const decryptedId = decryptId(id);
                getDataByApi(decryptedId);
            }
        }
    }, [token]);

    useEffect(() => {
        if (isPlaying) {
            timerRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev > 0) return prev - 1;
                    clearInterval(timerRef.current);
                    resetSettings();
                    return 0;
                });
            }, 1000);
        } else {
            clearInterval(timerRef.current);
        }

        return () => clearInterval(timerRef.current);
    }, [isPlaying]);

    const getDataByApi = async (mix_id) => {
        try {
            const response = await axios.get(`${BASEURL}/api/sounds/sounds_mixture/${mix_id}`);
            if (response.data.data) {
                const [{ sounds_list, propagation_code, isPlaylist }] = response.data.data;
                setPropagationCode(propagation_code);
                if (isPlaylist) {
                    const data = sounds_list[0]['sounds_detail'][0];
                    setTracks([{
                        id: data.id,
                        url: getMediaUrl(data),
                        title: data.title,
                        volume: 1,
                        playing: false,
                        loop: true,
                    }])
                    setAudioData([{
                        name: data.title,
                        type: data.type,
                        isPlaylist: true,
                        image: PlaylistIcon
                    }])
                } else {
                    makeSoundAudioTrackDataSet(sounds_list);
                }
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setSharedMixDeleted(true);
        }
    }

    const getDataByPlaylistApi = async (id) => {
        try {
            const locationPath = location?.pathname?.split('/')[1];
            const url = locationPath === "share.playlist.default" ? `/api/user/playlists?subId=${id}` : `/api/user/playlists/${id}/`;
            const response = await axios.get(BASEURL + url);
            if (response.data.data) {
                const data = response?.data?.data?.tracks[0];
                setTracks([{
                    id: data.id,
                    url: getMediaUrl(data),
                    title: data.title,
                    volume: 1,
                    playing: false,
                    loop: true,
                }])
                setAudioData([{
                    name: data.title,
                    type: data.type,
                    isPlaylist: true,
                    image: PlaylistIcon
                }])
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const makeSoundAudioTrackDataSet = (data) => {
        const audios = [];
        const sounds = [];
        const newArray = [];

        data?.forEach((item) => {
            const detail = item.sounds_detail?.[0];
            if (!detail) return;

            // split into audios & sounds
            if (item.type !== "sounds") {
                const itemLocal = { ...item, isPlaylist: false };
                audios.push(itemLocal);
            } else {
                sounds.push(item);
            }

            // build track object
            newArray.push({
                id: detail.id,
                url: getMediaUrl(detail),
                title: detail.title,
                volume: 1,
                playing: false,
                loop: detail.type === "sounds",
            });
        });

        setAudioData(audios);
        setSoundData(sounds);
        setTracks(newArray);

    }

    const getMediaUrl = (obj) => {
        if (obj['type'] !== "sounds") return obj['audio'];
        if (isMobileSafari || isSafari || isIOS) return obj['audio_mobile'] ? obj['audio_mobile'] : obj['ios_sound'];
        return obj['audio'];
    }

    const handleCreateAccount = () => {
        if (propagationCode) {
            navigate(`/promo/${propagationCode}`);
        } else {
            navigate('/freetrial');
        }
    }

    const playPausePlayer = () => {
        setTracks((prev) =>
            prev.map((track) => ({ ...track, playing: !isPlaying }))
        );
        setIsPlaying((prev) => {
            if (!prev) {
                // if switching from pause → play, immediately tick once
                setTimeLeft((t) => (t > 0 ? t - 1 : 0));
            }
            return !prev;
        });
    };

    // format seconds -> mm:ss
    const formatTime = (secs) => {
        const m = Math.floor(secs / 60).toString().padStart(2, "0");
        const s = (secs % 60).toString().padStart(2, "0");
        return `${m}:${s}`;
    };

    const resetSettings = () => {
        setTimeLeft(limit);
        setIsPlaying(false);
        setTracks((prev) =>
            prev.map((track) => ({ ...track, playing: false }))
        );
        Object.values(playerRefs.current).forEach((player) => {
            if (player) player.seekTo(0);
        });
    };


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh' }}>
                <Spinner animation="border" role="status" className='text-white'>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        )
    }

    return (
        <>
            <div style={{ height: '100vh' }}>
                <div style={{ width: '85%' }} className='h-100 m-auto d-flex flex-column share-mix-external-layout'>
                    <div className="logo d-flex align-items-center justify-content-center pt-4 pt-sm-5">
                        <img src={logo} alt="Logo" className='external-logo' />
                    </div>
                    <div className='d-flex flex-column justify-content-center'>
                        <div className='text-center my-4'>
                            <p className='fw-light fs-6 m-auto'>Enjoy This Relaxing Sample</p>
                        </div>
                        <div className='share-mix-sound-pallete'>

                            {soundData && soundData.map((sound, index) => (
                                <div>
                                    {index == 0 && <h6 className='title fw-light mb-2'>Sounds & Music</h6>}
                                    <div className='external-mixer-pallete'>
                                        <div className="mixerSoundDetail py-2" key={index}>
                                            <div className="mixerSoundThumbnailWrapper flex-shrink-0">

                                                <div className="mixerSoundThumbnail mixerStyle">
                                                    <img src={sound.image} alt={sound.name} />
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="mixerAudioTitle m-0">{sound.name}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            ))}

                            {(audioData && audioData.length > 0) && (
                                <>
                                    <h6 className='title fw-light text-capitalize my-2'>{audioData[0].type}</h6>
                                    <div className=''>
                                        <div className="mixerSoundDetail py-2">
                                            <div className="mixerSoundThumbnailWrapper flex-shrink-0">
                                                <div className={`mixerSoundThumbnail mixerStyle ${audioData[0]?.isPlaylist && 'playlistThumbnail'}`}>
                                                    <img src={audioData[0].image} alt={audioData[0].name} />
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="mixerAudioTitle m-0">{audioData[0].name}</p>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {tracks.map((track) => (
                                <div className='d-none'>
                                    <ReactPlayer
                                        ref={(player) => (playerRefs.current[track.id] = player)}
                                        url={track.url}
                                        playing={track.playing}
                                        volume={track.volume}
                                        loop={track.loop}
                                        controls={true}
                                        height="60px"
                                        width="100%"
                                    />
                                </div>
                            ))}
                        </div>
                        <div className='d-flex justify-content-between gap-4 mt-5 mb-5'>
                            <button style={{ backgroundColor: '#a4a2b0' }} className='w-50 px-4 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0 mx-auto' onClick={playPausePlayer}>
                                <img src={isPlaying ? PreviewPauseButton : PreviewPlayButton} alt='Play Pause Button' style={{ width: '11px' }} />
                                <span className='ps-2' style={{ width: '50px' }}>{(timeLeft === limit) ? 'listen' : formatTime(timeLeft)}</span>
                            </button>
                        </div>
                    </div>
                    <div className='text-center mb-5 externalLink d-inline d-sm-flex justify-content-center'>
                        <span>To enjoy the entire Mix or Playlist, </span>
                        <Link to={`${BASEURLFrontend}/login`} className="light-color-hover">log in</Link>
                        <span> or </span>
                        <span className='light-color-hover text-decoration-underline cursor-pointer' onClick={handleCreateAccount}>create an account.</span>
                    </div>
                    <div className='text-center mb-2 opacity-50 pt-5'>
                        <small className='fw-light'>© 2020-2026 Scofa, LLC</small>
                    </div>
                </div>
            </div>

            <Modal
                show={_isSharedMixDeleted}
                centered
                className="invite-success-modal success-modal"
                backdrop="static"
            >
                <Modal.Body>
                    <div className="p-5 pt-2 px-4">
                        <div className="text-end pb-3">
                            <button className="closeButton notButton ms-auto" onClick={() => { setSharedMixDeleted(false); }}>
                                <img src={crossIcon} alt="" />
                            </button>
                        </div>
                        <h2 className="font-16 lh-16 my-5 fw-normal text-center">{userPrompts?.mix_deleted_by_sender}</h2>
                    </div>
                </Modal.Body>
            </Modal>
        </>

    )
}

export default SaveShareMixExternal;